/**
 * IBAN utils — frontendowa walidacja (mod 97 ISO 13616) + format display.
 *
 * Backend (apps/api/lib/validators/iban.ts) jest zrodlem prawdy — ten plik to
 * tylko UX (live feedback po blur). Nie korzystamy z `ibantools` zeby nie ciagnac
 * paczki do bundla SPA — algorytm mod-97 jest prosty.
 */

/** Strip spaces/hyphens, upcase. */
export function normalizeIban(input: string): string {
  return input.replace(/[\s-]+/g, '').toUpperCase();
}

/**
 * Walidacja mod-97. Zwraca true gdy:
 *   - zawiera tylko [A-Z0-9],
 *   - dlugosc 15-34,
 *   - mod 97 == 1.
 */
export function validateIban(input: string): boolean {
  const s = normalizeIban(input);
  if (s.length < 15 || s.length > 34) return false;
  if (!/^[A-Z0-9]+$/.test(s)) return false;
  // Move first 4 chars to end, then convert letters to numbers (A=10..Z=35).
  const rearranged = s.slice(4) + s.slice(0, 4);
  let expanded = '';
  for (const ch of rearranged) {
    if (ch >= '0' && ch <= '9') {
      expanded += ch;
    } else {
      expanded += String(ch.charCodeAt(0) - 55);
    }
  }
  // Mod 97 nad arbitrary-precision integer — chunkowo.
  let remainder = 0;
  for (let i = 0; i < expanded.length; i += 7) {
    const chunk = remainder.toString() + expanded.slice(i, i + 7);
    remainder = Number(chunk) % 97;
  }
  return remainder === 1;
}

/**
 * Display format: grupy po 4 znaki, oddzielone spacja.
 *   `PL61109010140000071219812874` → `PL61 1090 1014 0000 0712 1981 2874`
 */
export function formatIban(input: string): string {
  const s = normalizeIban(input);
  return s.replace(/(.{4})/g, '$1 ').trim();
}
